export default __webpack_public_path__ + "5021185e511784763bee0f4af32582ee.png";